import { IFormTypesGroupCategory } from "../../model/formconfiguration/FormTypesGroupCategory";
import { IFormTypesGroupCategoryService } from "../../service/formconfiguration/FormTypesGroupCategoryService";

export default class UpdateFormTypesGroupCategoryInteractor {
  private formTypesGroupCategoryService: IFormTypesGroupCategoryService;

  constructor(formTypesGroupCategoryService) {
    this.formTypesGroupCategoryService = formTypesGroupCategoryService;
  }

  async execute(formTypesGroupCategory: IFormTypesGroupCategory) {
    return this.formTypesGroupCategoryService.updateFormTypesGroupCategory(
      formTypesGroupCategory
    );
  }
}
